import classNames from "classnames";
import styles from "./AddOrganisation.module.scss";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import Modal from "../../common/Modal";
import PrimaryButton from "../../common/PrimaryButton";
import OutlinedButton from "../../common/OutlinedButton";

interface ISuccessModalProps {
  handleClose: () => void;
  modalOpen: boolean;

  password: string;
}

const SuccessModal = ({
  handleClose,
  modalOpen,
  password,
}: ISuccessModalProps) => {
  const { getValues } = useFormContext();
  const formValues = getValues();
  const { t } = useTranslation();

  // ─── Extracted Values from Form ───────────────────────────────────────
  const { email } = formValues;
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!modalOpen) {
      setCopied(false);
    }
  }, [modalOpen]);

  const onConfirm = () => {
    const SITE_URL = "https://portal.waffyapp.com/";
    const textToCopy = `البريد الإلكتروني\n(${email})\n\nكلمة المرور\n${password}\n\nرابط الموقع\n[${SITE_URL}](${SITE_URL})`;

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setCopied(true);
      })
      .catch((error) => {
        console.error("Failed to copy text: ", error);
      });
  };

  const onClose = () => {
    setCopied(false);
    handleClose();
  };

  return (
    <Modal
      visible={modalOpen}
      onCancel={handleClose}
      customModalClassName={styles.modalContainer}>
      <div className={classNames(styles.success_container)}>
        <img src="/assets/images/svg/Success_tick.svg" alt="success" />

        <div className={styles.headerContainer}>
          <h1 className={styles.title}>{t("organization_success_title")} </h1>
          <p className={styles.description}>
            {t("organization_success_description")}
          </p>
        </div>

        <div className={styles.dataContainer}>
          <div className={styles.dataContentContainer}>
            <img src="/assets/images/svg/email.svg" alt="email" />
            <div className={styles.dataContent}>
              <p className={styles.dataTitle}>{t("email")}</p>
              <p className={styles.dataDescription}>{email}</p>
            </div>
          </div>
          <div className={styles.divider}></div>
          <div className={styles.dataContentContainer}>
            <img src="/assets/images/svg/success_lock.svg" alt="password" />
            <div className={styles.dataContent}>
              <p className={styles.dataTitle}>{t("password")}</p>
              <p className={styles.dataDescription}>{password}</p>
            </div>
          </div>
        </div>

        <PrimaryButton
          onClick={onConfirm}
          style={{
            width: "100%",
            height: "48px",
            borderRadius: "8px",
            textAlign: "center",
            whiteSpace: "nowrap",
            fontSize: "1rem",
            lineHeight: "100%",
            fontWeight: 600,
            alignSelf: "flex-end",
            marginTop: "60px",
            background: copied ? "#3ECC85" : "#0D44AD",
          }}>
          <img
            src="/assets/images/svg/success_copy.svg"
            alt="copy"
            className={styles.copyIcon}
          />
          {copied ? t("lbl_copied") : t("copy_information")}
        </PrimaryButton>
        <OutlinedButton
          onClick={onClose}
          style={{
            width: "100%",
            color: "#0C4BC4",
            background: "#0C4BC41A",
            border: "none",
            fontSize: "1rem",
            fontWeight: 400,
            height: "48px",
            marginTop: "15px",
          }}>
          {t("close")}
        </OutlinedButton>
      </div>
    </Modal>
  );
};

export default SuccessModal;
